import {getVoiceFilters} from '@Panels/ai-voice-panel/ai-voice-panel.types';

export const getAvatarUrlForVoice = (idVoice: number): string | undefined => {
  const profile = getVoiceFilters().find((sub) => {
    return sub.id === idVoice;
  });
  return profile?.avatarUrl;
};
